/**
 * The label to display when selected the filter
 */
export const labelCompetenzeBadante = 'Competenze Badante';
